var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59996 7.88453L3.24097 5.52555L3.71277 5.04607L5.26662 6.59992V0.833252H5.93329V6.59992L7.48714 5.04607L7.95894 5.52555L5.59996 7.88453ZM2.01021 10.1666C1.70337 10.1666 1.44718 10.0638 1.24162 9.85825C1.03607 9.6527 0.933289 9.3965 0.933289 9.08967V7.47429H1.59996V9.08967C1.59996 9.19222 1.64269 9.28624 1.72816 9.37172C1.81363 9.45718 1.90765 9.49992 2.01021 9.49992H9.1897C9.29226 9.49992 9.38628 9.45718 9.47175 9.37172C9.55722 9.28624 9.59995 9.19222 9.59995 9.08967V7.47429H10.2666V9.08967C10.2666 9.3965 10.1638 9.6527 9.95829 9.85825C9.75273 10.0638 9.49654 10.1666 9.1897 10.1666H2.01021Z",
    fill: "#003DA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.f11921691f821ad9b6064ddcb6f2c86f.svg";
export { ForwardRef as ReactComponent };